function setupRActionSign() {
  ractionSetup($('#rsign'));
  $('#rsign form').submit(function () {
    $('#rsign button.btn-primary').prop('disabled', true);
    $('#rsign .fa-spinner').show();
    $.post($(this).attr('action'), $(this).serialize()).done(function (data) {
      nextAction();
    }).fail(function (jqXHR) {
      $('#rsign').replaceWith(jqXHR.responseText);
    });
    return false;
  });
}

function loadComments() {
  if ($('.recent-comments').not('.no-animation').length) {
    $('.recent-comment').hide();
    $('.recent-comment:first').show();
    var commentLength = function(text) {

      var length = Math.ceil(text.split(' ').length * 0.2);
      if (length < 3) {

        length = 3;
      }
      return length * 1000;
    };
    var nextComment = function() {

      var nextSlide = $('.recent-comment:visible').next('.recent-comment');
      nextSlide = (nextSlide.length > 0) ? nextSlide : $('.recent-comment:first');

      $('.recent-comment:visible').fadeOut(300, function() {
        nextSlide.fadeIn(300);
      });
      setTimeout(function() {
        nextComment();
      }, commentLength($('.recent-comment-text', nextSlide).text()));
    };

    setTimeout(function() {
      nextComment();
    }, commentLength($('.recent-comment:first .recent-comment-text').text()));
  }
}

function loadSignatures() {
  $('#open-letter-load-signatures').hide();
  $('#open-letter-signature-list').html('');
  $('#open-letter-signature-list').after('<img id="signatures-loader" src="/images/loader.gif" />');
  $.getJSON(`/campaigns/${window.Campaign.id}/signatures`, function(data) {
    data.forEach(function(sig) {
      $('#open-letter-signature-list').append('<div class="open-letter-signature" style="font-size: 17px;">' + sig + '</div>');
    });
    $('#signatures-loader').remove();
  });
}

$(document).ready(function() {
  $('#open-letter-load-signatures').on('click', loadSignatures);
});


/*** EXPORTS FROM exports-loader ***/
exports["setupRActionSign"] = (setupRActionSign);
exports["loadComments"] = (loadComments);
exports["loadSignatures"] = (loadSignatures);